import Basic from "./Basic";
import Confirmation from "./Confirmation";

export default {
  Basic,
  Confirmation
};
